import { IValidationRule } from "@/types"

const assetCategoryValidationRules: { [s: string]: IValidationRule } = {
    name: {
        required: true,
    },
}

export default assetCategoryValidationRules
